import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useLang, errorText } from "@/lib/i18n";

const KEYS = ["new_event", "assignments", "reminders", "messages"];

export const NotificationPrefs = ({ keys = KEYS, compact = false }) => {
  const { t } = useLang();
  const { user, setUser } = useAuth();
  const prefs = Object.fromEntries(keys.map((k) => [k, (user.email_prefs || {})[k] !== false]));
  const toggle = async (k, v) => {
    try {
      const r = await api.put("/me/profile", { email_prefs: { [k]: v } });
      setUser(r.data);
      toast.success(t("c.saved"), { duration: 1200 });
    } catch (e) {
      toast.error(errorText(t, e));
    }
  };
  return (
    <div className={compact ? "" : "card-lux p-6 sm:p-8 rise mt-6"} data-testid="notification-prefs">
      <div className="flex items-center gap-2 mb-1"><BellRing className="w-4 h-4 text-[#C5A059]" /><h2 className={`font-display ${compact ? "text-lg" : "text-2xl"}`}>{t("np.title")}</h2></div>
      <p className="text-xs text-neutral-500 mb-5">{t("np.sub")}</p>
      <div className="divide-y divide-black/[0.05]">
        {keys.map((k) => (
          <label key={k} className="flex items-center justify-between gap-4 py-3.5 cursor-pointer">
            <span className="min-w-0">
              <span className="block text-sm font-medium">{t(`np.${k}`)}</span>
              <span className="block text-[11px] text-neutral-500 mt-0.5">{t(`np.${k}Hint`)}</span>
            </span>
            <Switch data-testid={`pref-${k}`} checked={prefs[k]} onCheckedChange={(v) => toggle(k, v)} />
          </label>
        ))}
      </div>
      <p className="text-[11px] text-neutral-400 mt-4" data-testid="notification-prefs-always">{t("np.always")}</p>
    </div>
  );
};
